(function () {
  'use strict';

  function getVariants() {
    // 从 script 标签文本中提取 VRS 数组
    const scripts = Array.from(document.querySelectorAll('script:not([src])'));
    const varScript = scripts.find(s => s.textContent.includes('var VRS='));
    if (!varScript) return [];
    try {
      const match = varScript.textContent.match(/var VRS=(\[[\s\S]*?\]);/);
      if (!match) return [];
      return JSON.parse(match[1]);
    } catch (e) {
      console.error('VRS parse error:', e);
      return [];
    }
  }

  // 缓存变体数据，避免重复解析
  let cachedVariants = null;
  function getVariantsCached() {
    if (!cachedVariants) cachedVariants = getVariants();
    return cachedVariants;
  }

  function getSelectedOption1Value() {
    const active = document.querySelector('.cdp-sc.act[data-oi="0"]');
    return active ? active.dataset.v : null;
  }

  function updateOption2Visibility() {
    const variants = getVariantsCached();
    if (!variants.length) return;

    const selectedOption1 = getSelectedOption1Value();
    if (!selectedOption1) return;

    const availableOption2 = new Set(
      variants
        .filter(v => v.option1 === selectedOption1)
        .map(v => v.option2)
        .filter(Boolean)
    );

    const option2Buttons = Array.from(
      document.querySelectorAll('.cdp-pill[data-oi="1"]')
    );

    let selectedWasHidden = false;
    let firstVisible = null;

    option2Buttons.forEach(btn => {
      const isAvailable = availableOption2.has(btn.dataset.v);
      btn.style.display = isAvailable ? '' : 'none';
      if (isAvailable && !firstVisible) firstVisible = btn;
      if (!isAvailable && btn.classList.contains('act')) {
        selectedWasHidden = true;
      }
    });

    if (selectedWasHidden && firstVisible) {
      firstVisible.click();
    }
  }

  document.addEventListener('click', (e) => {
    const sc = e.target.closest('.cdp-sc[data-oi="0"]');
    if (sc) setTimeout(updateOption2Visibility, 50);
  });

  function init() {
    if (document.querySelector('.cdp-sc[data-oi="0"]')) {
      updateOption2Visibility();
    } else {
      setTimeout(init, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
